import { utils } from "ethers";

// Ensure addresses are checksummed and properly formatted
const formatAddress = (address: string) => {
  try {
    return utils.getAddress(address);
  } catch (e) {
    console.error("Invalid address:", address);
    return address;
  }
};

export const CONTRACT_ADDRESSES = {
  base: "0x07e9324b757F1846a1c4f17832757eb64D6Eb6aD",
  pulsechain: "0xAD010CA83aCF225b4D11109ef925f120A37de7e9",
} as const;